import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { Tag } from "antd";
import styles from "./UnitInformation.module.scss";

const UnitInformation = ({ units, setSection }) => {
  const level_colors = ["magenta", "green", "cyan", "gold"];
  const unit = units.length > 0 ? units[units.length - 1] : null;
  const onGetInformation = (unitName, unitId) => {
    setSection(1);
  };
  return unit ? (
    <div className={styles["unit-information"]}>
      <div className={styles["title"]}>
        <p>{unit.name}</p>
        <Tag color={level_colors[unit.level - 1]}>Level {unit.level}</Tag>
      </div>
      <div className={styles["info"]}>
        <div className={styles["statistic"]}>
          {IconPack.unit_faculty_members}
          <p>
            <span>{numberRegex(unit.total_faculties)}</span> Faculty Members
          </p>
        </div>
        <div className={styles["statistic"]}>
          {IconPack.unit_publications}
          <p>
            <span>{numberRegex(unit.total_publication)}</span> Publications
          </p>
        </div>
      </div>
      <div
        className={styles["detail"]}
        onClick={() => onGetInformation(unit.name, unit.id)}
      >
        <button>View detail information</button>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default UnitInformation;
